var getCardatronCards, ls_ttl, service, setCards, template, tracky, ttl_ms,
  hasProp = {}.hasOwnProperty;

ls_ttl = require('localstorage-ttl');

tracky = require('../../../src/frontend/helper/general/m_trackEvent');

template = require('../../gig_body/header/sub_nav/components/cards/cards.html.mustache');

service = 'cards';

ttl_ms = 1000 * 60 * 60;

setCards = function(data) {
  var $navContainer, $subNavCardatron, cuiClass, key, rendered, tilesLeft, value;
  for (key in data) {
    if (!hasProp.call(data, key)) continue;
    value = data[key];
    $navContainer = $(".subnav .subnav-flyout." + key + "-tab-flyout");
    $subNavCardatron = $navContainer.find('.subnav-cardatron');
    if (!_.isEmpty(value) && $subNavCardatron.length) {
      tilesLeft = 4 - $navContainer.find('.subnav-categories').length;
      cuiClass = (function() {
        switch (tilesLeft) {
          case 4:
            return 'cui-four-up';
          case 3:
            return 'cui-three-up';
          case 2:
            return 'cui-two-up';
          case 1:
            return 'cui-one-up';
        }
      })();
      value.cards = value.cards.slice(0, tilesLeft);
      rendered = template.render(value);
      $subNavCardatron.replaceWith(rendered);
      $subNavCardatron = $navContainer.find('.subnav-cards').addClass(cuiClass);
    } else {
      tracky('ls-cardatron-render-error', {
        err: key + " response doesn't contain cards"
      });
      $subNavCardatron.remove();
    }
  }
};

getCardatronCards = function() {
  var attributes, brand, cacheData, cll, ell, storageKey;
  ell = Cookie.get('ell');
  cll = Cookie.get('cll');
  storageKey = 'sls_cardatron_cards';
  brand = $('head').data('brand');
  cacheData = ls_ttl.get(storageKey);
  if ((cacheData != null) && (cacheData.ell === ell && cacheData.cll === cll && cacheData.brand === brand)) {
    setCards(cacheData.cards);
    return;
  }
  attributes = {
    service: service,
    clientSideRequest: true
  };
  $.ajax({
    type: 'GET',
    url: '/layout/calls/service',
    timeout: 5000,
    data: attributes,
    success: function(arg) {
      var cacheValue, data, err;
      data = arg.data, err = arg.err;
      if (err != null) {
        tracky('ls-cardatron-error', {
          err: err
        });
        return;
      }
      cacheValue = {
        cll: cll,
        ell: ell,
        brand: brand,
        cards: data
      };
      try {
        ls_ttl.set(storageKey, cacheValue, ttl_ms);
      } catch (error) {}
      return setCards(data);
    }
  });
};

module.exports = {
  getCardatronCards: getCardatronCards
};

